import i18n from '@/utils/i18n';
import React from 'react';
import { BaseActionSheet } from './base-action-sheet';
import { Button } from './button';
import { SCREEN_PADDING, TYPOGRAPHY } from '@/styles';
import { StyleSheet, Text, View } from 'react-native';
import { TrackingData } from '@/utils/analytics/base-reporter';
import { useLayoutContext } from '@/contexts/layout-context';
import { useTheme } from '@/contexts/theme-context';

interface Props {
  confirmTrackingData: TrackingData | null;
  message: string;
  onConfirm: () => void;
  onSkip: () => void;
  skipTrackingData: TrackingData | null;
  title: string;
}

export const FormExitConfirmation: React.FC<Props> = ({
  confirmTrackingData,
  message,
  onConfirm,
  onSkip,
  skipTrackingData,
  title,
}) => {
  const theme = useTheme();
  const { isSmallLayout } = useLayoutContext();
  return (
    <BaseActionSheet isVisible onClose={onSkip} title={title}>
      {isSmallLayout ? (
        <Text style={[TYPOGRAPHY.h2, styles.textPlacement, styles.title]}>
          {title}
        </Text>
      ) : null}
      <Text
        style={[
          TYPOGRAPHY.actionSheetMessageText,
          styles.textPlacement,
          { color: theme.colors.inactiveText },
        ]}
      >
        {message}
      </Text>
      <View style={styles.confirmationSpacing}>
        <Button
          onPress={onSkip}
          trackingData={confirmTrackingData}
          type="primary"
        >
          <Text>{i18n.t('stay')}</Text>
        </Button>
      </View>
      <View style={styles.confirmationSpacing}>
        <Button
          onPress={onConfirm}
          trackingData={skipTrackingData}
          type="danger"
        >
          <Text>{i18n.t('leave_without_saving')}</Text>
        </Button>
      </View>
    </BaseActionSheet>
  );
};

const styles = StyleSheet.create({
  confirmationSpacing: {
    paddingBottom: 8,
  },
  textPlacement: {
    paddingBottom: SCREEN_PADDING,
    textAlign: 'center',
  },
  title: {
    marginBottom: 0,
  },
});
